'use strict';

var FaresManagerClassUsageTransformerFactory = function FaresManagerClassUsageTransformerFactory(DataTransformer) {
  function FaresManagerClassUsageTransformerFactory() {
    DataTransformer.call(this);
    this.sourceType = 'fares-chart-mode';
    this.priority = 1;
  }
  FaresManagerClassUsageTransformerFactory.prototype = Object.create(DataTransformer.prototype);
  FaresManagerClassUsageTransformerFactory.constructor = FaresManagerClassUsageTransformerFactory;
  FaresManagerClassUsageTransformerFactory.prototype.canTransform = function (sourceType) {
    return this.sourceType === sourceType;
  };
  FaresManagerClassUsageTransformerFactory.prototype.isCacheable = function () {
    return true;
  };
  FaresManagerClassUsageTransformerFactory.prototype.getCacheKey = function () {
    return this.sourceType;
  };
  FaresManagerClassUsageTransformerFactory.prototype.transform = function (data) {
    var revenueAccountingData = data.domain.results;
    for (var i = 0, length = revenueAccountingData.length; i < length; i++) {
      var current = revenueAccountingData[i];
      current.market = current.marketOrigin + '-' + current.marketDestination;
    }
    return revenueAccountingData;
  };
  return FaresManagerClassUsageTransformerFactory;
};
FaresManagerClassUsageTransformerFactory.$inject = ['DataTransformerFactory'];
module.exports = FaresManagerClassUsageTransformerFactory;